//@ts-nocheck
import React from 'react'
import {
  Field,
  FieldLabel,
  TextInput,
  ToggleSwitch
} from '../../../../../../../../../index'
import '../style.css'


export const EmbedLinkBody = ({ singleSelectedRowId, setState, state }) => {
  const { linkDetails } = state;
  const url = singleSelectedRowId.key !== '' ? (singleSelectedRowId?.data?.url?.length ? singleSelectedRowId.data.url : 'undefined') : (linkDetails?.['href'] ? linkDetails?.['href'] : '/');

  return (
    <div className='FormFields' style={{ width: '100%', padding: '24px 16px' }}>
      <Field>
        <FieldLabel required={true} version='v2' htmlFor='text'>URL</FieldLabel>
        <TextInput
          version='v2'
          name="text"
          value={url}
          disabled={true}
          type="text"
          placeholder="Entry URL Here"
          autoComplete="off"
          required={true}
        />
      </Field>
      <Field>
        <FieldLabel version='v2' htmlFor='text'>Display Text</FieldLabel>
        <TextInput
          version='v2'
          name="text"
          value={state.linkDetails.text}
          onChange={(e) => {
            e.persist();
            const text = e.target.value
            setState(prevState => ({
              ...prevState,
              linkDetails: {
                ...prevState.linkDetails,
                text: text
              }
            }))
          }}
          type="text"
          placeholder="Enter Link Text"
          autoComplete="off"
        />
      </Field>
      <div className='ToggleWrap'>
        <ToggleSwitch
          label="Open link in new tab"
          name='inNewTab'
          checked={state.linkDetails.inNewTab}
          onChange={(e) => {
            e.persist();
            const val = e.target.checked
            setState(prevState => ({
              ...prevState,
              linkDetails: {
                ...prevState.linkDetails,
                inNewTab: val
              }
            }))
          }}
          testId='entry-as-link-open-in-new-tab'
        />
      </div>
    </div>
  )
}